/** Needed for @i18n/next */
"use client";

/** Explicit exports */
export {
  IntlErrorCode,
  useFormatter,
  useLocale,
  useNow,
  useTranslations,
} from "use-intl";
